import { enqueueSnackbar } from 'notistack';

/**
 * Global notification service that can be used outside React components
 * This is particularly useful for axios interceptors and service files
 */

const notificationService = {
  success: (message, options = {}) => {
    enqueueSnackbar(message, {
      variant: 'success',
      autoHideDuration: 3000,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      ...options,
    });
  },

  error: (message, options = {}) => {
    enqueueSnackbar(message, {
      variant: 'error',
      autoHideDuration: 4000,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      ...options,
    });
  },

  warning: (message, options = {}) => {
    enqueueSnackbar(message, {
      variant: 'warning',
      autoHideDuration: 3500,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      ...options,
    });
  },

  info: (message, options = {}) => {
    enqueueSnackbar(message, {
      variant: 'info',
      autoHideDuration: 3000,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      ...options,
    });
  },
};

export default notificationService;
